/* A.L.M — Maison · core interactions */
(function(){
  'use strict';
  var D=document, W=window;
  var $=function(s,c){return (c||D).querySelector(s);};
  var $$=function(s,c){return Array.prototype.slice.call((c||D).querySelectorAll(s));};

  /* ---------- money ---------- */
  var FMT = (D.body && D.body.getAttribute('data-am-money')) || ('$'+'{{amount}}');
  function fmt(cents, format){
    var f = format || FMT, v = '';
    if(typeof cents==='string') cents = cents.replace('.','');
    function th2(num,sep,dec,pl){ if(isNaN(num)||num===null) return '0';
      num=(num/100).toFixed(pl); var parts=num.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+sep) + (parts[1]?dec+parts[1]:''); }
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    switch(m && m[1]){
      case 'amount_no_decimals': v=th2(cents,',','.',0); break;
      case 'amount_with_comma_separator': v=th2(cents,'.',',',2); break;
      case 'amount_with_space_separator': v=th2(cents,' ',',',2); break;
      case 'amount_no_decimals_with_comma_separator': v=th2(cents,'.',',',0); break;
      case 'amount_no_decimals_with_space_separator': v=th2(cents,' ',',',0); break;
      default: v=th2(cents,',','.',2);
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  W.amMoney = fmt;

  /* ---------- reveal ---------- */
  var io = ('IntersectionObserver' in W) ? new IntersectionObserver(function(en){
    en.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target);} });
  },{rootMargin:'0px 0px -8% 0px',threshold:.05}) : null;
  function reveal(scope){
    $$('.am-rv',scope||D).forEach(function(el){ if(io){io.observe(el);} else {el.classList.add('is-in');} });
  }
  reveal();
  W.amReveal = reveal;
  /* Safety nets: a backgrounded tab never runs IntersectionObserver, and a slow
     observer must never leave real content invisible. */
  D.addEventListener('visibilitychange',function(){ if(!D.hidden) reveal(); });
  W.setTimeout(function(){
    $$('.am-rv:not(.is-in)').forEach(function(el){
      var r=el.getBoundingClientRect();
      if(r.top < (W.innerHeight||0) + 200) el.classList.add('is-in');
    });
  },2200);

  /* ---------- sticky header ---------- */
  /* Some contexts (notably the Shopify theme preview bar) move scrolling from the
     document onto .page-wrapper. Resolve the real scroller once, then listen there. */
  var hd=$('[data-am-header]'), last=0, grp=$('#header-group'), _sc;
  function scroller(){
    if(_sc===undefined){
      var e=$('.page-wrapper');
      _sc=(e && e.scrollHeight>e.clientHeight+4 && /auto|scroll/.test(getComputedStyle(e).overflowY)) ? e : null;
    }
    return _sc;
  }
  function scrollY(){
    var s=scroller();
    return s ? s.scrollTop : (W.pageYOffset || D.documentElement.scrollTop || 0);
  }
  function measureHeader(){
    var ann=$('.am-ann-sec'), h=$('.am-hd');
    D.documentElement.style.setProperty('--am-ann-h',(ann?ann.offsetHeight:0)+'px');
    if(h) D.documentElement.style.setProperty('--am-hdr',h.offsetHeight+'px');
  }
  measureHeader();
  W.addEventListener('resize',measureHeader,{passive:true});
  if(D.fonts && D.fonts.ready) D.fonts.ready.then(measureHeader);
  function onScroll(){
    var y = scrollY();
    if(hd){
      hd.classList.toggle('is-stuck', y>8);
      var open = D.body.classList.contains('am-noscroll');
      if(!open && y>420 && y>last+4){ hd.classList.add('is-hidden'); }
      else if(y<last-4 || y<120){ hd.classList.remove('is-hidden'); }
      D.body.classList.toggle('am-hdr-hidden', hd.classList.contains('is-hidden'));
    }
    last=y;
    if(W.amStickyAtc) W.amStickyAtc(y);
  }
  W.addEventListener('scroll',onScroll,{passive:true});
  (function(){ var s=scroller(); if(s) s.addEventListener('scroll',onScroll,{passive:true}); })();
  W.amScrollY=scrollY;
  onScroll();

  /* ---------- announcement rotator ---------- */
  $$('[data-am-ann]').forEach(function(w){
    var sl=$$('.am-ann__s',w); if(sl.length<2) return;
    var i=0,t;
    function go(n){ sl[i].classList.remove('is-on'); i=(n+sl.length)%sl.length; sl[i].classList.add('is-on'); }
    function play(){ t=setInterval(function(){go(i+1);}, parseInt(w.getAttribute('data-am-ann'),10)||5200); }
    function stop(){ clearInterval(t); }
    var p=$('[data-am-ann-prev]',w), n=$('[data-am-ann-next]',w);
    if(p) p.addEventListener('click',function(){stop();go(i-1);play();});
    if(n) n.addEventListener('click',function(){stop();go(i+1);play();});
    w.addEventListener('mouseenter',stop); w.addEventListener('mouseleave',play);
    play();
  });

  /* ---------- overlay + drawers ---------- */
  var ov=$('[data-am-overlay]');
  var lastFocus=null;
  function openDrawer(name){
    var dw=$('[data-am-drawer="'+name+'"]'); if(!dw) return;
    lastFocus=D.activeElement;
    $$('[data-am-drawer]').forEach(function(d){ d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); });
    dw.classList.add('is-open'); dw.removeAttribute('aria-hidden');
    if(ov) ov.classList.add('is-open');
    D.body.classList.add('am-noscroll');
    var f=dw.querySelector('input:not([type=hidden]),button,a[href]'); if(f) setTimeout(function(){try{f.focus();}catch(e){}},280);
    D.dispatchEvent(new CustomEvent('am:drawer:open',{detail:{name:name}}));
  }
  function closeAll(){
    $$('[data-am-drawer]').forEach(function(d){ d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); });
    if(ov) ov.classList.remove('is-open');
    D.body.classList.remove('am-noscroll');
    if(lastFocus && lastFocus.focus){ try{lastFocus.focus();}catch(e){} }
  }
  W.amDrawer = {open:openDrawer, close:closeAll};
  D.addEventListener('click',function(e){
    var o=e.target.closest('[data-am-open]');
    if(o){ e.preventDefault(); openDrawer(o.getAttribute('data-am-open')); return; }
    if(e.target.closest('[data-am-close]')){ e.preventDefault(); closeAll(); return; }
    if(ov && e.target===ov){ closeAll(); }
  });
  D.addEventListener('keydown',function(e){
    if(e.key==='Escape'){ closeAll(); $$('.am-mega.is-open').forEach(function(m){m.classList.remove('is-open');}); }
    if(e.key==='Tab'){
      var dw=$('[data-am-drawer].is-open'); if(!dw) return;
      var f=$$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])',dw)
        .filter(function(el){return el.offsetParent!==null;});
      if(!f.length) return;
      var first=f[0], lastE=f[f.length-1];
      if(e.shiftKey && D.activeElement===first){ e.preventDefault(); lastE.focus(); }
      else if(!e.shiftKey && D.activeElement===lastE){ e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- mega menu (touch / keyboard) ---------- */
  $$('[data-am-mega-toggle]').forEach(function(b){
    b.addEventListener('click',function(e){
      var m=b.parentElement.querySelector('.am-mega'); if(!m) return;
      if(W.matchMedia('(hover:hover)').matches) return;
      e.preventDefault();
      var open=m.classList.toggle('is-open');
      b.setAttribute('aria-expanded',open?'true':'false');
    });
  });

  /* ---------- mobile nav ---------- */
  D.addEventListener('click',function(e){
    var b=e.target.closest('[data-am-mnav]'); if(!b) return;
    var p=b.nextElementSibling; if(!p) return;
    e.preventDefault();
    var open=p.classList.toggle('is-open');
    b.setAttribute('aria-expanded',open?'true':'false');
  });

  /* ---------- accordions ---------- */
  D.addEventListener('click',function(e){
    var b=e.target.closest('[data-am-acc]'); if(!b) return;
    var p=b.parentElement.querySelector('.am-acc__p'); if(!p) return;
    var group=b.getAttribute('data-am-acc-group');
    if(group){
      $$('[data-am-acc-group="'+group+'"]').forEach(function(o){
        if(o===b) return; o.setAttribute('aria-expanded','false');
        var op=o.parentElement.querySelector('.am-acc__p'); if(op) op.classList.remove('is-open');
      });
    }
    var open=p.classList.toggle('is-open');
    b.setAttribute('aria-expanded',open?'true':'false');
  });

  /* ---------- filter groups ---------- */
  D.addEventListener('click',function(e){
    var b=e.target.closest('[data-am-fl]'); if(!b) return;
    var p=b.nextElementSibling; if(!p) return;
    var open=p.classList.toggle('is-open');
    b.setAttribute('aria-expanded',open?'true':'false');
  });

  /* ---------- tabs ---------- */
  $$('[data-am-tabs]').forEach(function(w){
    var tabs=$$('[role=tab]',w);
    tabs.forEach(function(t,i){
      t.addEventListener('click',function(){
        tabs.forEach(function(o){ o.setAttribute('aria-selected','false');
          var pn=D.getElementById(o.getAttribute('aria-controls')); if(pn) pn.hidden=true; });
        t.setAttribute('aria-selected','true');
        var p=D.getElementById(t.getAttribute('aria-controls')); if(p){p.hidden=false; reveal(p);}
      });
      t.addEventListener('keydown',function(e){
        var n = e.key==='ArrowRight'?i+1 : e.key==='ArrowLeft'?i-1 : -1;
        if(n<0) return; e.preventDefault();
        var nx=tabs[(n+tabs.length)%tabs.length]; nx.focus(); nx.click();
      });
    });
  });

  /* ---------- rails ---------- */
  $$('[data-am-rail]').forEach(function(r){
    var t=$('[data-am-rail-track]',r); if(!t) return;
    var pv=$('[data-am-rail-prev]',r), nx=$('[data-am-rail-next]',r), pg=$('[data-am-rail-prog]',r);
    function step(){ var c=t.children[0]; return c ? c.offsetWidth+24 : t.clientWidth*.8; }
    function upd(){
      var max=t.scrollWidth-t.clientWidth;
      if(pv) pv.disabled = t.scrollLeft<=4;
      if(nx) nx.disabled = t.scrollLeft>=max-4;
      if(pg) pg.style.transform='scaleX('+(t.scrollWidth>0?Math.max(.08,Math.min(1,(t.scrollLeft+t.clientWidth)/t.scrollWidth)):1)+')';
    }
    if(pv) pv.addEventListener('click',function(){ t.scrollBy({left:-step(),behavior:'smooth'}); });
    if(nx) nx.addEventListener('click',function(){ t.scrollBy({left:step(),behavior:'smooth'}); });
    t.addEventListener('scroll',upd,{passive:true});
    W.addEventListener('resize',upd); upd();
  });

  /* ---------- toast ---------- */
  var toastEl, toastT;
  function toast(msg){
    if(!toastEl){
      toastEl=D.createElement('div'); toastEl.className='am-toast'; toastEl.setAttribute('role','status');
      toastEl.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg><span></span>';
      D.body.appendChild(toastEl);
    }
    toastEl.querySelector('span').textContent=msg;
    toastEl.classList.add('is-on'); clearTimeout(toastT);
    toastT=setTimeout(function(){ toastEl.classList.remove('is-on'); },3200);
  }
  W.amToast=toast;

  /* ---------- qty steppers ---------- */
  D.addEventListener('click',function(e){
    var b=e.target.closest('[data-am-qty]'); if(!b) return;
    var wrap=b.closest('.am-qty'); var inp=wrap && wrap.querySelector('input'); if(!inp) return;
    var v=parseInt(inp.value,10)||1;
    v = b.getAttribute('data-am-qty')==='up' ? v+1 : Math.max(parseInt(inp.getAttribute('min')||'1',10), v-1);
    inp.value=v; inp.dispatchEvent(new Event('change',{bubbles:true}));
  });

  /* ---------- cart ---------- */
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function sized(url,w){ if(!url) return ''; return url.replace(/(\.(jpg|jpeg|png|webp|gif))(\?|$)/i, '_'+w+'x$1$3'); }

  function paintCount(n){
    $$('[data-am-cart-count]').forEach(function(el){
      el.textContent=n; el.classList.toggle('is-on', n>0);
      el.setAttribute('aria-label', n+' items in bag');
    });
  }
  function renderCart(cart){
    paintCount(cart.item_count);
    var body=$('[data-am-cart-body]'), foot=$('[data-am-cart-foot]');
    if(!body) return;
    if(!cart.item_count){
      body.innerHTML='<div class="am-cart__empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p class="am-h3">Your bag is empty</p><p class="am-small" style="margin-top:8px">Discover pieces made for everyday use.</p><a class="am-btn am-btn--ghost am-btn--sm" style="margin-top:22px" href="/collections/all" data-am-close>Browse the collection</a></div>';
      if(foot) foot.hidden=true;
      return;
    }
    if(foot) foot.hidden=false;
    body.innerHTML = cart.items.map(function(it){
      var img = it.image ? '<img src="'+sized(it.image,180)+'" alt="'+esc(it.product_title)+'" width="82" height="82" loading="lazy">' : '';
      var vt = (it.variant_title && it.variant_title!=='Default Title') ? '<div class="am-ci__v">'+esc(it.variant_title)+'</div>' : '';
      var was = it.original_line_price>it.final_line_price ? ' <s class="am-pr--was">'+fmt(it.original_line_price)+'</s>' : '';
      return '<div class="am-ci" data-am-line="'+it.key+'">'+
        '<a class="am-ci__img am-media" href="'+it.url+'" data-am-close style="--x:0">'+img+'</a>'+
        '<div><a href="'+it.url+'" data-am-close class="am-ci__t">'+esc(it.product_title)+'</a>'+vt+
        '<div class="am-ci__row"><div class="am-qty"><button type="button" data-am-qty="down" aria-label="Decrease quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg></button>'+
        '<input type="number" min="0" value="'+it.quantity+'" data-am-line-qty aria-label="Quantity"><button type="button" data-am-qty="up" aria-label="Increase quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg></button></div>'+
        '<div class="am-ci__p">'+fmt(it.final_line_price)+was+'</div></div>'+
        '<button type="button" class="am-small" style="margin-top:10px;text-decoration:underline;text-underline-offset:3px" data-am-remove>Remove</button>'+
        '</div></div>';
    }).join('');
    var tot=$('[data-am-cart-total]'); if(tot) tot.textContent=fmt(cart.total_price);
    (function(){
      var bar=$('[data-am-ship]'); if(!bar) return;
      var th=parseInt(bar.getAttribute('data-threshold'),10)||0;
      var msg=$('[data-am-ship-msg]',bar), pr=$('[data-am-ship-prog]',bar);
      if(!th){ bar.hidden=true; return; }
      bar.hidden=false;
      var left=th-cart.total_price;
      if(left>0){
        if(msg) msg.innerHTML='You are '+'<b>'+fmt(left)+'</b>'+' away from free worldwide shipping.';
        bar.classList.remove('is-done');
      }else{
        if(msg) msg.innerHTML='<b>Free worldwide shipping unlocked.</b>';
        bar.classList.add('is-done');
      }
      if(pr) pr.style.width=Math.max(0,Math.min(100,(cart.total_price/th)*100))+'%';
    })();
    var sav=$('[data-am-cart-savings]');
    if(sav){
      var d=(cart.original_total_price||0)-(cart.total_price||0);
      sav.hidden = d<=0; if(d>0) sav.textContent='You save '+fmt(d);
    }
  }
  function getCart(open){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();})
      .then(function(c){ renderCart(c); if(open) openDrawer('cart'); return c; });
  }
  W.amCartRefresh=getCart;

  /* The cart page mirrors the drawer: re-render it from the Section Rendering API. */
  function refreshCartPage(){
    var host=$('[data-am-cart-page]'); if(!host) return;
    var sid=host.getAttribute('data-section-id'); if(!sid) return;
    host.style.opacity='.5';
    return fetch('/cart?section_id='+encodeURIComponent(sid))
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var inc=doc.querySelector('[data-am-cart-page]');
        if(inc){ host.innerHTML=inc.innerHTML; if(W.amReveal) W.amReveal(host); }
      })
      .catch(function(){})
      .then(function(){ host.style.opacity=''; });
  }

  function changeLine(key,qty){
    var b=$('[data-am-cart-body]'); if(b) b.style.opacity='.5';
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();})
      .then(function(c){ renderCart(c); refreshCartPage(); if(b) b.style.opacity=''; });
  }
  D.addEventListener('change',function(e){
    var i=e.target.closest('[data-am-line-qty]'); if(!i) return;
    var line=i.closest('[data-am-line]'); if(!line) return;
    changeLine(line.getAttribute('data-am-line'), Math.max(0,parseInt(i.value,10)||0));
  });
  D.addEventListener('click',function(e){
    var r=e.target.closest('[data-am-remove]'); if(!r) return;
    var line=r.closest('[data-am-line]'); if(!line) return;
    changeLine(line.getAttribute('data-am-line'),0);
  });

  function addToCart(payload,btn){
    var label = btn ? btn.innerHTML : null;
    if(btn){ btn.setAttribute('aria-disabled','true'); btn.innerHTML='<span>Adding…</span>'; }
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(payload)})
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
      .then(function(){ return getCart(true); })
      .catch(function(err){ toast((err && (err.description||err.message)) || 'Sorry, that item could not be added.'); })
      .then(function(){ if(btn){ btn.removeAttribute('aria-disabled'); btn.innerHTML=label; } });
  }
  W.amAdd=addToCart;

  /* quick add from cards */
  D.addEventListener('click',function(e){
    var b=e.target.closest('[data-am-quick-add]'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    addToCart({items:[{id:parseInt(b.getAttribute('data-am-quick-add'),10),quantity:1}]},b);
  });

  /* product form */
  $$('[data-am-product-form]').forEach(function(f){
    f.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=f.querySelector('[data-am-atc]');
      var fd=new FormData(f); var o={};
      fd.forEach(function(v,k){ o[k]=v; });
      addToCart({items:[{id:parseInt(o.id,10),quantity:parseInt(o.quantity||1,10)}]},btn);
    });
  });

  /* ---------- variant picker ---------- */
  $$('[data-am-variants]').forEach(function(holder){
    var data; try{ data=JSON.parse(holder.textContent); }catch(err){ return; }
    var scope=holder.closest('[data-am-product]'); if(!scope) return;
    var idInput=$('[data-am-variant-id]',scope);
    var handle=scope.getAttribute('data-am-product');
    function current(){
      return $$('[data-am-opt]:checked',scope).sort(function(a,b){
        return (+a.getAttribute('data-am-opt'))-(+b.getAttribute('data-am-opt'));
      }).map(function(i){return i.value;});
    }
    function match(sel){
      return data.filter(function(v){ return sel.every(function(val,i){ return v.options[i]===val; }); })[0];
    }
    function availability(sel){
      $$('[data-am-opt]',scope).forEach(function(inp){
        var pos=(+inp.getAttribute('data-am-opt'))-1;
        var test=sel.slice(); test[pos]=inp.value;
        var ok=data.some(function(v){ return v.available && test.every(function(val,i){ return i===pos ? v.options[i]===val : (val===undefined||v.options[i]===val); }); });
        inp.disabled = !ok && data.length>1 && sel.length===data[0].options.length;
      });
    }
    function paint(v){
      var lbl;
      $$('[data-am-opt-current]',scope).forEach(function(el){
        var pos=(+el.getAttribute('data-am-opt-current'))-1;
        var chk=$('[data-am-opt="'+(pos+1)+'"]:checked',scope);
        if(chk) el.textContent=chk.value;
      });
      var priceBox=$('[data-am-price]',scope);
      var atc=$('[data-am-atc]',scope);
      if(!v){
        if(atc){ atc.disabled=true; atc.querySelector('span').textContent='Unavailable'; }
        return;
      }
      if(idInput) idInput.value=v.id;
      if(priceBox){
        var h='<span class="am-pr'+(v.compare_at_price>v.price?' am-pr--sale':'')+'">'+fmt(v.price)+'</span>';
        if(v.compare_at_price>v.price){
          h+='<s class="am-pr am-pr--was">'+fmt(v.compare_at_price)+'</s>';
          h+='<span class="am-pd__save">Save '+Math.round((1-v.price/v.compare_at_price)*100)+'%</span>';
        }
        priceBox.innerHTML=h;
      }
      if(atc){
        atc.disabled=!v.available;
        var s=atc.querySelector('span'); if(s) s.textContent = v.available ? (atc.getAttribute('data-am-label')||'Add to bag') : 'Sold out';
      }
      $$('[data-am-sticky-price]',D).forEach(function(el){ el.textContent=fmt(v.price); });
      var st=$('[data-am-stock]',scope);
      if(st){ st.hidden=!v.available; }
      if(v.featured_media_index!=null){
        var stage=$('[data-am-gal-track]',scope);
        if(stage && stage.children[v.featured_media_index]) {
          stage.scrollTo({left:stage.children[v.featured_media_index].offsetLeft-stage.offsetLeft,behavior:'smooth'});
        }
      }
      if(W.history && W.history.replaceState && handle){
        var u=new URL(W.location.href); u.searchParams.set('variant',v.id); W.history.replaceState({},'',u.toString());
      }
    }
    scope.addEventListener('change',function(e){
      if(!e.target.matches('[data-am-opt]')) return;
      var sel=current(); availability(sel); paint(match(sel));
    });
    var sel0=current(); availability(sel0); if(data.length>1) paint(match(sel0));
  });

  /* ---------- sticky add to cart ---------- */
  (function(){
    var bar=$('[data-am-sticky]'); if(!bar) return;
    var anchor=$('[data-am-atc]');
    W.amStickyAtc=function(y){
      if(!anchor){ bar.classList.toggle('is-on', y>700); return; }
      var r=anchor.getBoundingClientRect();
      var past = r.bottom < 0;
      var footer=$('[data-am-sticky-stop]');
      var nearEnd = footer ? footer.getBoundingClientRect().top < W.innerHeight : false;
      bar.classList.toggle('is-on', past && !nearEnd);
    };
    var sb=$('[data-am-sticky-add]');
    if(sb) sb.addEventListener('click',function(){
      var f=$('[data-am-product-form]');
      if(f){ f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit',{cancelable:true})); }
    });
  })();

  /* ---------- product gallery ---------- */
  $$('[data-am-gallery]').forEach(function(g){
    var track=$('[data-am-gal-track]',g);
    var thumbs=$$('[data-am-gal-thumb]',g);
    var dots=$$('[data-am-gal-dot]',g);
    if(!track) return;
    function setActive(i){
      thumbs.forEach(function(t,n){ t.classList.toggle('is-on',n===i); t.setAttribute('aria-current',n===i?'true':'false'); });
      dots.forEach(function(d,n){ d.classList.toggle('is-on',n===i); });
      $$('video',track).forEach(function(v,n){ if(n!==i){ try{v.pause();}catch(e){} } });
    }
    thumbs.forEach(function(t,i){
      t.addEventListener('click',function(){
        var s=track.children[i]; if(!s) return;
        track.scrollTo({left:s.offsetLeft-track.offsetLeft,behavior:'smooth'}); setActive(i);
      });
    });
    var tk;
    track.addEventListener('scroll',function(){
      clearTimeout(tk);
      tk=setTimeout(function(){
        var i=Math.round(track.scrollLeft/track.clientWidth); setActive(i);
      },90);
    },{passive:true});
    setActive(0);
  });

  /* ---------- before / after ---------- */
  $$('[data-am-ba]').forEach(function(el){
    var aft=$('.am-ba__aft',el), h=$('.am-ba__h',el); if(!aft||!h) return;
    var drag=false;
    function set(x){
      var r=el.getBoundingClientRect();
      var p=Math.max(2,Math.min(98,((x-r.left)/r.width)*100));
      aft.style.width=p+'%'; h.style.left=p+'%';
      h.setAttribute('aria-valuenow',Math.round(p));
    }
    function down(e){ drag=true; set((e.touches?e.touches[0]:e).clientX); }
    function move(e){ if(!drag) return; set((e.touches?e.touches[0]:e).clientX); }
    function up(){ drag=false; }
    el.addEventListener('mousedown',down); el.addEventListener('touchstart',down,{passive:true});
    W.addEventListener('mousemove',move); W.addEventListener('touchmove',move,{passive:true});
    W.addEventListener('mouseup',up); W.addEventListener('touchend',up);
    h.addEventListener('keydown',function(e){
      var cur=parseFloat(aft.style.width)||50;
      if(e.key==='ArrowLeft'){ cur-=4; } else if(e.key==='ArrowRight'){ cur+=4; } else return;
      e.preventDefault(); cur=Math.max(2,Math.min(98,cur)); aft.style.width=cur+'%'; h.style.left=cur+'%';
    });
  });

  /* ---------- collection filters ---------- */
  $$('[data-am-filter-form]').forEach(function(f){
    var t;
    /* Keep empty inputs out of the query string so filtered URLs stay clean and shareable. */
    function tidy(){
      $$('input',f).forEach(function(i){
        if(i.type==='checkbox'){ i.disabled=!i.checked; }
        else { i.disabled = (i.value==='' || i.value==null); }
      });
    }
    f.addEventListener('submit',tidy);
    f.addEventListener('change',function(){
      clearTimeout(t);
      t=setTimeout(function(){ tidy(); f.submit(); },160);
    });
  });
  $$('[data-am-sort]').forEach(function(s){
    s.addEventListener('change',function(){
      var u=new URL(W.location.href);
      u.searchParams.set('sort_by',s.value); u.searchParams.delete('page');
      W.location.href=u.toString();
    });
  });

  /* ---------- grid layout toggle ---------- */
  $$('[data-am-layout]').forEach(function(b){
    b.addEventListener('click',function(){
      var grid=$('[data-am-grid]'); if(!grid) return;
      $$('[data-am-layout]').forEach(function(o){o.classList.toggle('is-on',o===b);});
      grid.style.setProperty('--am-cols', b.getAttribute('data-am-layout'));
      try{ localStorage.setItem('am-cols', b.getAttribute('data-am-layout')); }catch(e){}
    });
  });
  (function(){
    var grid=$('[data-am-grid]'); if(!grid) return;
    var saved=null; try{ saved=localStorage.getItem('am-cols'); }catch(e){}
    if(!saved) return;
    var b=$('[data-am-layout="'+saved+'"]'); if(!b) return;
    $$('[data-am-layout]').forEach(function(o){o.classList.toggle('is-on',o===b);});
    grid.style.setProperty('--am-cols', saved);
  })();

  /* ---------- product recommendations ---------- */
  $$('[data-am-recs]').forEach(function(sec){
    var url=sec.getAttribute('data-url'); if(!url) return;
    fetch(url).then(function(r){return r.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var incoming=doc.querySelector('[data-am-recs]');
      if(incoming && incoming.innerHTML.trim()){
        sec.innerHTML=incoming.innerHTML;
        sec.classList.remove('am-sec--none');
        if(incoming.className) sec.className=incoming.className;
        reveal(sec);
        var r=sec.closest('[data-am-recs]');
        $$('[data-am-rail]',sec).forEach(function(rl){
          var t=$('[data-am-rail-track]',rl);
          var pv=$('[data-am-rail-prev]',sec), nx=$('[data-am-rail-next]',sec), pg=$('[data-am-rail-prog]',rl);
          if(!t) return;
          function step(){ var c=t.children[0]; return c?c.offsetWidth+24:t.clientWidth*.8; }
          function upd(){ var max=t.scrollWidth-t.clientWidth;
            if(pv) pv.disabled=t.scrollLeft<=4; if(nx) nx.disabled=t.scrollLeft>=max-4;
            if(pg) pg.style.transform='scaleX('+Math.max(.08,Math.min(1,(t.scrollLeft+t.clientWidth)/t.scrollWidth))+')'; }
          if(pv) pv.addEventListener('click',function(){t.scrollBy({left:-step(),behavior:'smooth'});});
          if(nx) nx.addEventListener('click',function(){t.scrollBy({left:step(),behavior:'smooth'});});
          t.addEventListener('scroll',upd,{passive:true}); upd();
        });
      }
    }).catch(function(){});
  });

  /* init cart count on load */
  if($('[data-am-cart-body]')) getCart(false);

  /* ---------- expandable rich text ---------- */
  $$('[data-am-expand]').forEach(function(w){
    var body=$('.am-rte',w), btn=$('[data-am-expand-btn]',w);
    if(!body||!btn) return;
    function measure(){
      if(w.classList.contains('is-open')) return;
      w.classList.toggle('is-short', body.scrollHeight <= body.clientHeight + 12);
    }
    measure();
    W.addEventListener('load',measure);
    W.addEventListener('resize',measure,{passive:true});
    btn.addEventListener('click',function(){
      var open=w.classList.toggle('is-open');
      btn.setAttribute('aria-expanded',open?'true':'false');
      $$('[data-am-expand-more]',btn).forEach(function(e){e.hidden=open;});
      $$('[data-am-expand-less]',btn).forEach(function(e){e.hidden=!open;});
      if(!open){ try{ w.scrollIntoView({block:'nearest',behavior:'smooth'}); }catch(e){} }
    });
  });

})();
